var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Provides the contract contact information editing form within the declaration flow.
 * touches: contract store, contract contact validation, contract edition actions, Claims IA design system components.
 * invariants: changes can be saved only when contact data is valid and differs from the original contract; cancelling exits without saving; validation is revealed on an invalid save or no detected difference.
 * inputs: selected contract contact information, contract edition state, validation context.
 * outputs: renders editable contact fields, updates the contract draft, saves valid changes, emits cancel or saved to the parent.
 */
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton, UiCard } from '@claims-ia/design-system';
const contract = namespace('contract');
let ContractModification = class ContractModification extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.revealDiffError = false;
    }
    mounted() {
        this.editContract();
    }
    get canSave() {
        return this.validation.isValid && this.contractInEditionHasDiff;
    }
    cancel() {
        this.cancelContractEdition();
        this.$emit('cancel');
    }
    validate() {
        this.revealDiffError = true;
        this.validateContractContact();
    }
    async saveClaimContract() {
        this.loading = true;
        await this.saveContractInEdition().catch(() => (this.loading = false));
        this.$emit('saved');
        this.$buefy.toast.open({
            message: this.$tc('contract.modification.toast.message'),
            type: 'is-info',
            position: 'is-bottom',
        });
    }
};
__decorate([
    contract.State('selectedContract')
], ContractModification.prototype, "contract", void 0);
__decorate([
    contract.State('contractInEditionHasDiff')
], ContractModification.prototype, "contractInEditionHasDiff", void 0);
__decorate([
    contract.Getter('validation')
], ContractModification.prototype, "validation", void 0);
__decorate([
    contract.Action('updateContractContact')
], ContractModification.prototype, "updateContact", void 0);
__decorate([
    contract.Action('validateContractContact')
], ContractModification.prototype, "validateContractContact", void 0);
__decorate([
    contract.Action('saveContractInEdition')
], ContractModification.prototype, "saveContractInEdition", void 0);
__decorate([
    contract.Action('editContract')
], ContractModification.prototype, "editContract", void 0);
__decorate([
    contract.Action('cancelContractEdition')
], ContractModification.prototype, "cancelContractEdition", void 0);
ContractModification = __decorate([
    Component({
        components: {
            UiButton,
            UiCard,
        },
    })
], ContractModification);
export default ContractModification;
